import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

//project components
import config from "../../../../config";

//third party
import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import { Box, Card, Typography } from "@mui/material";
import { Grid } from "swiper";
import JobPost from "../../../../components/job-post/JobPost";

const AppliedJobs = (props) => {
  const { candidateId } = props;
  const axiosAuth = useAxiosAuth();
  const [jobApplications, setJobApplications] = useState();

  const getJobApplications = () => {
    axiosAuth
      .get("/api/JobApplications/by-candidate?candidateId=" + candidateId)
      .then((response) => {
        setJobApplications(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getJobApplications();
  }, []);
  console.log("Candidate", jobApplications);
  return (
    <Card sx={{ padding: 2 }} elevation={3}>
      <Typography sx={{ marginBottom: 2 }} variant="h6" color="primary">
        My Job Applications
      </Typography>
      {jobApplications?.length > 0 ? (
        <Box>
          {jobApplications?.map((row) => (
            <Box key={row.id} sx={{ marginBottom: 2 }}>
              <JobPost
                jobPost={row.jobPost}
                type={1}
                jobApplications={jobApplications}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <Typography textAlign="center" sx={{ margin: 5 }}>
          You have not applied to any job posts yet.
        </Typography>
      )}
    </Card>
  );
};

export default AppliedJobs;
